import type { RestaurantAttendance } from '../types/restaurantPersonnel';

const civilDatePattern = /^(\d{4})-(\d{2})-(\d{2})/;
const civilDateTimePattern = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;

export const formatCivilDate = (value: string | null | undefined): string => {
  if (!value) return '';
  const match = civilDatePattern.exec(value);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : value;
};

export const formatCivilDateTime = (value: string | null | undefined): string => {
  if (!value) return '';
  const match = civilDateTimePattern.exec(value);
  return match ? `${match[3]}.${match[2]}.${match[1]} ${match[4]}:${match[5]}` : value;
};

export const formatHours = (value: number, precision = 4, includeUnit = true): string => {
  const formatted = value.toFixed(precision).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1').replace('.', ',');
  return includeUnit ? `${formatted} год` : formatted;
};

type AttendanceHours = Pick<RestaurantAttendance, 'checkOutAt' | 'hoursWorked'>;

export const formatAttendanceIntervalHours = (interval: AttendanceHours): string =>
  interval.checkOutAt ? formatHours(interval.hoursWorked) : 'години не враховано';

export const sumCompletedAttendanceHours = (intervals: readonly AttendanceHours[]): number =>
  intervals.reduce((total, interval) => total + (interval.checkOutAt ? interval.hoursWorked : 0), 0);
